import type React from 'react'
import type { ChartRow } from './ChartRow.ts'
import { StackedBarChartNext } from './StackedBarChartNext.tsx'
import type { StackSeries } from './StackSeries.ts'

interface AreaChartPlotProps {
  data: ChartRow[]
  stackSeries: StackSeries[]
  onBarClick: (key: string) => void
  ylabel: string
  xlabel: string
  xTickMaxChars?: number
  xTickRotate?: number
  height?: number | `${number}%`
  hideCaption?: boolean
  /** Samples per bucket, aligned to `data` by index; shown in the tooltip. */
  sampleCounts?: (number | undefined)[]
}

/**
 * Stacked area chart. Thin delegate over the shared echarts `StackedBarChartNext` (`variant="area"`).
 * Stacks on `xAxisvalue`.
 */
export const AreaChartPlot: React.FC<AreaChartPlotProps> = ({
  data,
  stackSeries,
  onBarClick,
  ylabel,
  xlabel,
  xTickMaxChars,
  xTickRotate,
  height,
  hideCaption,
  sampleCounts
}) => (
  <>
    {hideCaption !== true && <h2 className="text-2xl font-semibold mb-6">Stacked Area Chart: Taxonomy by Sample</h2>}
    <StackedBarChartNext
      variant="area"
      dataKey="xAxisvalue"
      data={data}
      sampleCounts={sampleCounts}
      stackSeries={stackSeries}
      ylabel={ylabel}
      xlabel={xlabel}
      onBarClick={onBarClick}
      xTickMaxChars={xTickMaxChars}
      xTickRotate={xTickRotate}
      height={height}
    />
  </>
)
